var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgGavel = function SvgGavel(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none",
    viewBox: "0 0 34 34",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3d96ff",
    d: "M6.538 27.625h14.167q.303 0 .505.203a.7.7 0 0 1 .203.505q0 .303-.203.505a.7.7 0 0 1-.505.203H6.538a.7.7 0 0 1-.505-.203.7.7 0 0 1-.203-.505q0-.303.203-.505a.7.7 0 0 1 .505-.203m6.122-7.936-3.811-3.812a2.23 2.23 0 0 1-.67-1.592q-.017-.942.634-1.62l.428-.455 7.094 7.024-.455.454q-.65.652-1.61.652t-1.61-.651m9.407-6.187-7.023-7.095.455-.427a2.2 2.2 0 0 1 1.62-.634 2.23 2.23 0 0 1 1.592.67l3.811 3.81q.651.652.651 1.61 0 .96-.651 1.61zm6.615 13.349L11.676 9.846l1.003-1.003 17.005 17.005a.7.7 0 0 1 .213.488.66.66 0 0 1-.213.515.7.7 0 0 1-.5.226.7.7 0 0 1-.502-.226"
  })));
};
export default SvgGavel;